import { render } from "./LegalFooter.vue?vue&type=template&id=1327479d"
import script from "./LegalFooter.vue?vue&type=script&lang=js"
export * from "./LegalFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__